module.exports = __webpack_public_path__ + "img/bootes.e29c2ad0.png";